import { useDateLocale, useTimeZone } from '../../../../hooks'
import { RentalPortalViewingProfileNote } from '../RentalPortalViewingProfileNote'
import { RentalPortalViewingProfileOutcome } from '../RentalPortalViewingProfileOutcome'
import { RentalPortalViewingProfileRescheduleHistory } from '../RentalPortalViewingProfileRescheduleHistory'

import * as styles from './RentalPortalViewingProfileOverview.module.css'

function RentalPortalViewingProfileOverview() {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <div className={styles.RentalPortalViewingProfileOverview}>
      <RentalPortalViewingProfileNote />
      <RentalPortalViewingProfileOutcome locale={locale} timezone={timezone} />
      <RentalPortalViewingProfileRescheduleHistory
        locale={locale}
        timezone={timezone}
      />
    </div>
  )
}

export default RentalPortalViewingProfileOverview
